import { IBaseDraftDDBHeader, IDDBDraftHeaderRequest } from '../api/duty-drawback-api.model';

export const mapIDDBDraftHeaderResponseToRequest = (draftResponse: IBaseDraftDDBHeader): IDDBDraftHeaderRequest => {

  return {
    ...draftResponse,
    draftUid: draftResponse.draftUid,
    draftUiContent: draftResponse.draftUiContent,
    etag: draftResponse.etag
  };
};
